import img_1 from 'assets/Images/partners/partner1.png'
import img_2 from 'assets/Images/partners/partner2.png'
import img_3 from 'assets/Images/partners/partner3.png'
import img_4 from 'assets/Images/partners/partner4.png'
import img_5 from 'assets/Images/partners/partner5.png'
import img_6 from 'assets/Images/partners/partner6.png'

//================= OUR PARTNERS  HOME COMPONENT ===============
const OurPartners = () => {
    return (
        <section id="ourPartners">
            <div className="container pb-4">
                <div className="row text-white">
                    <h2>Our Trusted Partners</h2>
                    <p className="py-3 fw-normal">Cyan Trusted Partners are certified consulting agencies that we connect with businesses looking <br/> to jumpstart our services to perfection</p>
                </div>
            </div>
            <div className="cs_container">
                <div className="row partners_s_row">
                    <img src={img_1} alt="" />
                    <img src={img_2} alt="" />
                    <img src={img_3} alt="" />
                    <img src={img_4} alt="" />
                    <img src={img_5} alt="" />
                    <img src={img_6} alt="" />
                </div>
            </div>
        </section>
    )
}

export default OurPartners
